import {orderBy} from 'lodash'
import moment from 'moment-timezone'

import {KpiDefinitionDto, KpiValueDto, KpiValuesById, KpiValueVersionsById} from '../types'

export const getLatestKpiMonthValue = (
  kpiValues: KpiValueDto[],
  monthNumber: number
): KpiValueDto | undefined => {
  const values = orderBy(kpiValues, 'version', 'desc')
  const monthValue = values.find((x) => x.month === monthNumber)
  return monthValue
}

export const getLatestKpiMonthValueOrDefault = (
  kpiValues: KpiValueDto[],
  monthNumber: number
): KpiValueDto => {
  const latestValue = getLatestKpiMonthValue(kpiValues, monthNumber)
  if (latestValue) return latestValue

  return {
    id: '',
    month: monthNumber,
    value: undefined,
    version: 0,
    hasComments: false
  }
}

export const getMonthsDetails = (language: string) => {
  const monthsNumbers = Array.from({length: 12}, (_, i) => i + 1)
  const monthsNames = monthsNumbers.map((month) =>
    moment()
      .month(month - 1)
      .locale(language)
      .format('MMMM')
  )

  return {numbers: monthsNumbers, names: monthsNames}
}

export const getAllKpiValuesById = (
  kpiDefinitions: KpiDefinitionDto[],
  isEditableOrCreatable: (month: number, year: number, value: number | undefined) => boolean
): KpiValuesById => {
  return kpiDefinitions.reduce((valuesById, kpiDefinition) => {
    for (let month = 1; month <= 12; month++) {
      const latestValue = getLatestKpiMonthValue(kpiDefinition.kpiValues, month)

      if (!isEditableOrCreatable(month, kpiDefinition.year, latestValue?.value)) continue

      if (latestValue) {
        valuesById[latestValue.id] = latestValue.value ?? undefined
      }
    }
    return valuesById
  }, {} as KpiValuesById)
}

export const getAllVersionsByKpiValueId = (
  kpiDefinitions: KpiDefinitionDto[],
  isEditableOrCreatable: (month: number, year: number, value: number | undefined) => boolean
): KpiValueVersionsById => {
  return kpiDefinitions.reduce((valuesById, kpiDefinition) => {
    for (let month = 1; month <= 12; month++) {
      const latestValue = getLatestKpiMonthValue(kpiDefinition.kpiValues, month)

      if (!isEditableOrCreatable(month, kpiDefinition.year, latestValue?.value)) continue

      if (latestValue) {
        valuesById[latestValue.id] = latestValue.version
      }
    }
    return valuesById
  }, {} as KpiValueVersionsById)
}
